import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMatchText({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [imagesData, setImagesData] = useState(data.images);

    const [choices, setChoices] = useState({});
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [activeSelect, setActiveSelect] = useState(false);
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);

    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setImagesData(data.images);
        setChoices({});
        setSelectedChoice(null);
        setSelectedKeyPrevious(null);
        setAvailableChoices(makeArrayRandom(data.choices));
    }, [question,
        data.images,
        data.choices,
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setActiveSelect(true);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (choices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === choices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== choices[index]?.value)) {
            let currentChoices = {...choices};
            const previousChoice = choices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentChoices = {
                ...currentChoices,
                [index]: {
                    value: selectedChoice.value,
                },
            }
            setChoices(currentChoices);

            const answerValue = data?.initialState ?? questionData.answer.value;

            if (
                typeof answerValue === "object" &&
                !Array.isArray(answerValue)
            ) {
                const answerKeys = Object.keys(answerValue);

                const formattedAnswer = answerKeys.reduce(
                    (acc, key, keyIndex) => {
                        acc[key] = currentChoices[keyIndex]?.value || null;
                        return acc;
                    },
                    {}
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: formattedAnswer,
                });
            } else {
                const updatedAnswer = Object.values(currentChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
            setActiveSelect(false);
        }
    };

    const handleRemoveChoice = (index) => {
        if (!activeSelect) {
            const removedChoice = choices[index];
            
            if (removedChoice) {
                setChoices((prevChoices) => {
                    const newChoices = { ...prevChoices };
                    delete newChoices[index];

                    const answerValue = data?.initialState ?? questionData.answer.value;

                    if (
                        typeof answerValue === "object" &&
                        !Array.isArray(answerValue)
                    ) {
                        const answerKeys = Object.keys(
                            answerValue
                        );

                        let canProceed = false;
                        const formattedAnswer = answerKeys.reduce(
                            (acc, key, keyIndex) => {
                                acc[key] = newChoices[keyIndex]?.value || null;
                                if (acc[key] !== "" && acc[key] !== null) {
                                    canProceed = true;
                                }
                                return acc;
                            },
                            {}
                        );

                        onAnswer({
                            canProceed,
                            answer: formattedAnswer,
                        });
                    } else {
                        const updatedAnswer = Object.values(newChoices).map(
                            (choice) => choice.value
                        );

                        // set to false so that next button will be disabled
                        const canProceed = updatedAnswer.length > 0;
                        onAnswer({
                            canProceed,
                            answer: updatedAnswer,
                        });
                    }

                    return newChoices;
                });

                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    {
                        value: removedChoice.value,
                    },
                ]);
            }
        }
    };

    return (
        <Box
            sx={{
                width: "800px",
                margin: "0 auto",
                display: "flex",
            }}
        >
            <Box sx={{
                position: "relative",
                textAlign: "center",
            }}>
                <Box
                    sx={{
                        position: "relative",
                        width: "800px",
                        height: "120px",
                        marginBottom: "10px",
                        textAlign: "center",
                        border: "1px dashed lightgrey",
                    }}
                >
                    <Box sx={{
                        width: "100%",
                        height: "100%",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        placeItems: "center",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        textAlign: "center",
                    }}>
                        {availableChoices.map((choice, index) => (
                            <Box key={index} sx={{
                                borderBottom: "10px solid rgb(52, 148, 186)",
                                position: "relative",
                                height: "28px",
                                width: "264px",
                                boxShadow:
                                        selectedChoice?.value === choice.value
                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                            : "none",
                                display: "inline-block",
                                boxSizing: "content-box",
                                backgroundColor: "#aad6e7",
                                padding: "4px",
                                lineHeight: "1.4em",
                                textAlign: "center",
                                fontSize: "18px",

                            }}
                            onClick={() => { handleChoiceClick(choice) }}
                            disabled={selectedChoice === choice}
                            >
                                <Box sx={{ fontWeight: "bold" }}>
                                    { choice.value }
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box>
                    {imagesData && imagesData.map((image, index) => (
                        <Box key={index} sx={{
                            display: "grid",
                            marginTop: "100px",
                            placeItems: "center",
                            padding: "10px",
                            backgroundColor: "rgb(122, 140, 142)",
                            borderBottom: "10px solid rgb(91, 105, 107)",
                            gridTemplateColumns: "1fr 1fr",
                            borderRadius: "10px",
                            textAlign: "center",

                        }}>
                            {image.row.map((row, rowIndex) => (
                                <Box key={row.index} sx={{
                                    display: "inline-block",
                                    // width: "200px"
                                }}>
                                    <Box component="img" 
                                        src={`${imagesResources}${row.path}`}
                                        sx={{
                                            marginTop: choices[row.index]
                                                ? "-105px"
                                                : "-100px",
                                            marginRight: "-15px",
                                            textAlign: "center",
                                            width: "310px",
                                        }}
                                        alt={`Img ${row.index}`}
                                    />
                                    <Box sx={{
                                        height: "38px",
                                        width: "278px",
                                        position: "relative",
                                        display: "inline-block",
                                        boxSizing: "border-box",
                                        padding: "4px",
                                        lineBreak: "1em",
                                        textAlign: "center",
                                        boxShadow:
                                            selectedChoice
                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                : "none",
                                        backgroundColor: choices[row.index]
                                            ? "#aad6e7"
                                            : "white",
                                        borderTop: choices[row.index]
                                            ? "none"
                                            : "10px solid rgb(91, 105, 106)",
                                        fontSize: "18px",
                                        
                                    }}
                                    onClick={() => handleChoiceAssign(row.index)}
                                    >
                                        {/* For close button */}
                                        {choices[row.index] && (
                                            <Box
                                                className="selected-close-btn"
                                                sx={{
                                                    top: "0px",
                                                    right: "0px",
                                                    fontWeight:
                                                        typeof questionData.answer.value ===
                                                            "object" &&
                                                        !Array.isArray(
                                                            questionData.answer.value
                                                        )
                                                            ? "normal"
                                                            : "bold",
                                                    width: "17.33px",
                                                    maxHeight: "20px",
                                                    display: "flex",
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleRemoveChoice(row.index);
                                                }}
                                            >
                                                X
                                            </Box>
                                        )}
                                        {choices[row.index] ? (
                                        <Box
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >{choices[row.index].value}</Box>
                                            ) :
                                            <Box component="span"></Box>
                                        }
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};